import { enum_CONTRACTPARTIE_FORM_MODE } from "../../common/Dictionaries";
import { 
	SET_FIRST_LOAD,
	SET_EDP_CONFIG,
	SET_EDP_CONFIG_ERROR_VALIDATIONS,
	SET_EDP_CONFIG_OBJECT_PROPERTY,
	ADD_EDP_CONFIG_PARTY_GROUP,
	UPDATE_EDP_CONFIG_PARTY_GROUP,
	DELETE_EDP_CONFIG_PARTY_GROUP,
	UPDATE_EDP_CONFIG_PARTY_GROUP_CONFIG,
	UPDATE_EDP_CONFIG_DI,
	SET_FORM_MODE,
	UPDATE_EDP_ONPREPARING,
} from "../actions/PAY/edpConfigActions";

const initialState = {
	_formMode: enum_CONTRACTPARTIE_FORM_MODE.CREATE,
	_firsLoad: false,
	_edpConfigObject: null,
	_edpConfigGetted: null,
	_edpConfigErrorValidations: null,
	_edpOnPreparing: null
};

const edpConfigReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FORM_MODE:
			return {
				...state,
				_formMode: action.payload
			};

		case SET_FIRST_LOAD:
			return {
				...state,
				_firsLoad: action.payload
			};

		case SET_EDP_CONFIG:
			return {
				...state,
				_edpConfigObject: action.payload.object,
				_edpConfigGetted: action.payload.getted
			};

		case SET_EDP_CONFIG_ERROR_VALIDATIONS:
			return {
				...state,
				_edpConfigErrorValidations: action.payload,
			};

		case SET_EDP_CONFIG_OBJECT_PROPERTY:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					iteM_CONF_EP_CONTRATO: {
						...state._edpConfigObject.iteM_CONF_EP_CONTRATO,
						[action.payload.propertyName]: action.payload.propertyValue,
					},
				},
			};

		case ADD_EDP_CONFIG_PARTY_GROUP:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					l_GRUPO: [...state._edpConfigObject.l_GRUPO, action.payload],
				},
			};

		case UPDATE_EDP_CONFIG_PARTY_GROUP:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					l_GRUPO: state._edpConfigObject.l_GRUPO.map((item) =>
						item.id === action.payload.itemId ? { ...item, ...action.payload.group } : item
					),
				},
			};

		case DELETE_EDP_CONFIG_PARTY_GROUP:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					l_GRUPO: state._edpConfigObject.l_GRUPO.filter(item => item.id !== action.payload),
				},
			};

		case UPDATE_EDP_CONFIG_PARTY_GROUP_CONFIG:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					l_PARTIDAS_CONFIGURACION: state._edpConfigObject.l_PARTIDAS_CONFIGURACION.map((item) =>
						item.id === action.payload.itemId ? { ...item, ...action.payload.item } : item
					),
				},
			};

		case UPDATE_EDP_CONFIG_DI:
			return {
				...state,
				_edpConfigObject: {
					...state._edpConfigObject,
					l_CONF_EP_DI: state._edpConfigObject.l_CONF_EP_DI.map((item) =>
						item[action.payload.propertyNameId] === action.payload.itemId ? { ...item, ...action.payload.item } : item
					),
				},
			};	
		case UPDATE_EDP_ONPREPARING:
			return {
				...state,
				_edpOnPreparing: action.payload,
			};
			
		default:
			return state;
	}
};



export default edpConfigReducer;